import { makeStyles } from '@material-ui/core/styles'
import { Container, Button, Link } from '@material-ui/core'
import { PRESS, IMAGE_GUIDELINES } from '../../../routes'
import InThePressSection from './InThePressSection'

const useStyles = makeStyles((theme) => ({
    bg: {
        display: 'flex',
        justifyContent: 'center',
        padding: '0 0 3rem 0',
    },
    box: {
        padding: '1rem 0',
        borderBottom: `1px solid #dfdfdf`,
    },
    title: {
        fontWeight: '700',
        fontSize: '30px',
        marginTop: '2rem',
    },
    question: {
        fontSize: '15px',
        lineHeight: '18.8px',
        fontWeight: '700',
        textTransform: 'uppercase',
    },
    button: {
        color: 'white',
        borderRadius: '5px',
        fontWeight: '700',
        fontSize: '16px',
        padding: '10px 24px 10px 12px',
        border: `2px solid ${theme.palette.primary.main}`,
        background: theme.palette.primary.main,
        marginTop: '.5rem',
        display: 'block',
        textTransform: 'none',
        textAlign: 'center',
        [theme.breakpoints.up('sm')]: {
            width: '16rem',
        },
        [theme.breakpoints.up('md')]: {
            margin: '3rem 0',
        },
        '&:hover': {
            backgroundColor: `${theme.palette.primary.main}!important`,
            color: `white!important`,
        },
    },
    link: {
        color: '#222222',
        textDecoration: 'underline',
    },
    li: {
        listStyleType: 'disc!important',
        margin: '5px 0 0 20px',
    },
}))

const LegitBusinessSection = ({ baseUrl }) => {
    const classes = useStyles()

    return (
        <div className={classes.bg}>
            <Container>
                <h3 className={classes.title}>
                    Yes, Gift Card Granny is a legitimate business.
                </h3>
                <div className={classes.box}>
                    <p>
                        Gift Card Granny, founded by gift card pioneer and
                        entrepreneur{' '}
                        <Link
                            className={classes.link}
                            target={'_blank'}
                            rel={'noopener noreferrer'}
                            href={'https://www.jasonwolfe.com/'}
                        >
                            Jason Wolfe
                        </Link>
                        , is part of{' '}
                        <Link
                            className={classes.link}
                            target={'_blank'}
                            rel={'noopener noreferrer'}
                            href={'https://www.wolfe.com/'}
                        >
                            The Wolfe Companies
                        </Link>
                        , a trusted leader in the gifting industry. We've been
                        in business for many years and have a large base of
                        satisfied customers. In recognition of our rapid growth,
                        we were ranked the fastest-growing company in the
                        Pittsburgh metropolitan area on the Inc. 500 list in
                        2023. Our commitment to innovation is further
                        demonstrated by our state-of-the-art fulfillment center.
                        Opened in 2020, this 20,000 square foot facility is one
                        of the only secure print-on-demand facilities in the
                        country, ensuring the highest quality and security for
                        your personalized gift cards. To meet increasing demand,
                        we're expanding the facility by an additional 12,000
                        square feet in 2024.
                    </p>
                    <p>
                        <strong>
                            We partner with Visa and Mastercard to offer
                            customized gift cards, reward cards, and thousands
                            of retail gift cards.
                        </strong>
                    </p>

                    <Button className={classes.button} href={baseUrl + PRESS}>
                        View press & Media
                    </Button>
                </div>

                <div className={classes.box}>
                    <h3 className={classes.title}>Featured in the Media</h3>

                    <p>
                        Gift Card Granny has been featured in a variety of media
                        outlets, including Today and ABC News. These features
                        are a testament to our reputation and commitment to
                        providing a great customer experience.
                    </p>

                    <p>
                        <strong>As seen on:</strong>
                    </p>

                    <InThePressSection hideTitle={true}></InThePressSection>
                </div>

                <h3 className={classes.title}>
                    Why am I finding negative reviews of Gift Card Granny?
                </h3>
                <div className={classes.box} style={{ borderBottom: '0' }}>
                    <p>
                        At Gift Card Granny, we value honest feedback because it
                        helps us improve and provide a better customer
                        experience. We encourage customers to reach out with any
                        concerns about purchasing gift cards online. Here, we
                        address some common issues with complete transparency:
                    </p>
                    <h4 className={classes.question}>
                        “My custom visa or mastercard image was not approved”
                    </h4>
                    <p>
                        We offer custom gift cards with user-uploaded photos, in
                        partnership with Visa and Mastercard. Each photo is
                        reviewed by our team for strict adherence to their{' '}
                        <Link
                            className={classes.link}
                            href={baseUrl + IMAGE_GUIDELINES}
                        >
                            image guidelines
                        </Link>{' '}
                        . Uploads containing prohibited elements will be
                        rejected.
                    </p>
                    <h4 className={classes.question}>
                        “My virtual Digital Gift card was not delivered to my
                        recipient”
                    </h4>
                    <p>
                        Several factors might prevent Digital Gift card delivery
                        to your recipient. The most common are:
                        <ul>
                            <li className={classes.li}>
                                <strong>Spam/Junk folder:</strong> Check the
                                recipient's spam or junk folder for the Digital
                                Gift card email.
                            </li>
                            <li className={classes.li}>
                                <strong>Business email blocking:</strong> Some
                                business email domains block such messages.
                            </li>
                            <li className={classes.li}>
                                <strong>Incorrect email address:</strong>{' '}
                                Double-check the recipient's email address for
                                accuracy.
                            </li>
                        </ul>
                        If your Digital Gift card hasn't arrived, feel free to
                        contact us using the chat icon on the bottom right. We
                        can investigate delivery or update the recipient's email
                        address if needed. Most Digital Gift cards are sent
                        within 15 minutes, but some orders may undergo a manual
                        security review, causing delays of up to 4 hours. We
                        apologize for any inconvenience but prioritize security
                        for all customers.
                    </p>
                    <h4 className={classes.question}>
                        “my plastic gift card was not delivered to my recipient”
                    </h4>
                    <p>
                        We offer various shipping options for physical gift
                        cards. While printing and shipping typically occur
                        within the next business day, delivery times vary:
                        <ul>
                            <li className={classes.li}>
                                FedEx: Arrives within 2-3 business days.
                            </li>
                            <li className={classes.li}>
                                USPS: Standard delivery takes 10 business days.
                            </li>
                        </ul>
                        Shipping speeds may fluctuate during peak seasons like
                        holidays. If your recipient hasn't received their card
                        after the expected delivery window, we'll gladly issue a
                        free replacement or a full refund.
                    </p>
                    <p>
                        For quick answers to other common questions, you can
                        also visit our comprehensive{' '}
                        <Link
                            className={classes.link}
                            target={'_blank'}
                            rel={'noopener noreferrer'}
                            href={'https://help.giftcardgranny.com/hc/en-us'}
                        >
                            Help Center
                        </Link>
                        . Our Help Center covers a wide range of topics,
                        including order tracking, returns, and troubleshooting.
                    </p>
                </div>
            </Container>
        </div>
    )
}

export default LegitBusinessSection
